import { defineGlobalStyles } from '@chakra-ui/react';

export const globalCss = defineGlobalStyles({
  html: {
    lineHeight: 1.5,
    '--font-fallback':
      "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    // @ts-expect-error
    WebkitTextSizeAdjust: '100%',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
    touchAction: 'manipulation',
    MozTabSize: '4',
    tabSize: '4',
    fontFamily: 'var(--global-font-body, var(--font-fallback))',
  },
  '*': {
    margin: '0px',
    padding: '0px',
    userSelect: 'none',
    wordWrap: 'break-word',
    WebkitTapHighlightColor: 'transparent',
  },
  // NOTE: This is a global reset for all relevant elements except SVG;
  // it overrides the default Chakra reset which happens on ALL elements
  'div, span, a, button, input, label, select, option, textarea': {
    font: 'inherit',
  },
  '*, *::before, *::after, *::backdrop': {
    boxSizing: 'border-box',
    borderWidth: '0px',
    borderStyle: 'solid',
    borderColor: 'var(--global-color-border, currentColor)',
  },
  hr: {
    height: '0px',
    color: 'inherit',
    borderTopWidth: '1px',
  },
  body: {
    minHeight: '100dvh',
    position: 'relative',
  },
  img: {
    borderStyle: 'none',
    width: '100%',
  },
  'img, svg, video, canvas, audio, iframe, embed, object': {
    display: 'block',
    verticalAlign: 'middle',
  },
  iframe: {
    border: 'none',
  },
  'img, video': {
    height: 'auto',
  },
  'p, h1, h2, h3, h4, h5, h6': {
    overflowWrap: 'break-word',
  },
  'code, kbd, pre, samp': {
    fontSize: '1em',
  },
  'button, [type="button"], [type="reset"], [type="submit"]': {
    WebkitAppearance: 'button',
    backgroundColor: 'transparent',
    backgroundImage: 'none',
  },
  'button, input, optgroup, select, textarea': {
    color: 'inherit',
  },
  'button, select': {
    textTransform: 'none',
  },
  table: {
    textIndent: '0px',
    borderColor: 'inherit',
    borderCollapse: 'collapse',
  },
  '*::-webkit-input-placeholder': {
    opacity: 'unset',
    color: '#9ca3af',
  },
  '*::-moz-placeholder': {
    opacity: 'unset',
    color: '#9ca3af',
  },
  '*:-ms-input-placeholder': {
    opacity: 'unset',
    color: '#9ca3af',
  },
  '*::placeholder': {
    opacity: 'unset',
    color: '#9ca3af',
  },
  textarea: {
    resize: 'vertical',
  },
  summary: {
    display: 'list-item',
  },
  small: {
    fontSize: '80%',
  },
  'sub, sup': {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline',
  },
  sub: {
    bottom: '-0.25em',
  },
  sup: {
    top: '-0.5em',
  },
  dialog: {
    padding: '0px',
  },
  a: {
    color: 'inherit',
    textDecoration: 'inherit',
  },
  'abbr[title]': {
    textDecoration: 'underline dotted',
  },
  'b, strong': {
    fontWeight: 'semibold',
  },
  'code, kbd, samp, pre': {
    fontSize: '1em',
    '--font-mono-fallback':
      "ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New'",
    fontFamily: 'var(--global-font-mono, var(--font-mono-fallback))',
  },
  'input[type="text"], input[type="email"], input[type="search"], input[type="password"]':
    {
      WebkitAppearance: 'none',
      // @ts-expect-error
      MozAppearance: 'none',
    },
  'input[type="search"]': {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px',
  },
  '::-webkit-search-decoration, ::-webkit-search-cancel-button': {
    WebkitAppearance: 'none',
  },
  '::-webkit-file-upload-button': {
    WebkitAppearance: 'button',
    font: 'inherit',
  },
  'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button':
    {
      height: 'auto',
    },
  'input[type="number"]': {
    // @ts-expect-error
    MozAppearance: 'textfield',
  },
  ':-moz-ui-invalid': {
    boxShadow: 'none',
  },
  ':-moz-focusring': {
    outline: 'auto',
  },
  '[hidden]:not([hidden="until-found"])': {
    display: 'none !important',
  },
});
